import { useEffect, useState } from "react";
import { getEvaluationCategoryList } from "@/apis/supplier";

// ==================== 类型定义 ====================
export interface EvaluationCategoryOption {
  label: string;
  value: string;
}

interface EvaluationCategoryApiResponse {
  name: string;
  id: string;
  // 根据实际接口响应添加其他字段
  [key: string]: any;
}

// ==================== 自定义Hook ====================
/**
 * 获取评估分类选项的Hook
 * @param statusId 物料状态ID，当为空时返回空数组
 * @returns {Object} 返回评估分类选项和加载状态
 */
export const useEvaluationCategories = (statusId?: string) => {
  const [options, setOptions] = useState<EvaluationCategoryOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchEvaluationCategories = async () => {
      // 如果没有 statusId，清空选项并返回
      if (!statusId) {
        setOptions([]);
        return;
      }

      try {
        setLoading(true);
        const response = await getEvaluationCategoryList(statusId);

        // 接口返回 { data: [...] } 或 { data: { data: [...] } }
        const data = response.data?.data || response.data || [];

        if (Array.isArray(data) && data.length > 0) {
          // 将接口返回的 name 和 id 转换为 label 和 value
          const transformedOptions: EvaluationCategoryOption[] = data.map(
            (item: EvaluationCategoryApiResponse) => ({
              label: item.name,
              value: item.id,
            }),
          );
          setOptions(transformedOptions);
        } else {
          setOptions([]);
        }
      } catch (error) {
        // 失败时使用空数组
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchEvaluationCategories();
  }, [statusId]);

  return { options, loading };
};
